import { render } from "./SoftModelSwitch.vue?vue&type=template&id=2ecb7e43"
import script from "./SoftModelSwitch.vue?vue&type=script&lang=js"
export * from "./SoftModelSwitch.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__